import { useEffect, useRef, useState } from "react";
import useOutside from "../../hooks/useOutside";
import { debounce } from "lodash";
import "./TaskSizeButton.css"

const TaskSizeButton = (props) => {
    const { taskSizeValue, changeSize } = props;
    const [effortLevel, setEffortLevel] = useState(taskSizeValue ? taskSizeValue : 0);
    const [showInput, setShowInput] = useState(false);
    const [taskValue, setTaskValue] = useState("");
    const [imageSize, setImageSize] = useState("");
    const [taskDescription, setTaskDescription] = useState("");
    const ref = useRef();
    const buttonRef = useRef();
    const taskSizes = [
        { label: "Effort", description: "Requires some effort", size: "small" },
        { label: "Medium effort", description: "Requires moderate effort", size: "medium" },
        { label: "Large effort", description: "Requires a lot of effort: why not break it down into smaller tasks?", size: "large" }
    ];
    useOutside(ref, buttonRef, null, () => setShowInput(false));

    const handleClick = () => {
        setShowInput(prevState => !prevState);
    };

    useEffect(() => {
        setTaskLabels(taskSizeValue || 0);
    }, [taskSizeValue]);


    const setTaskLabels = (value) => {
        const { label, description, size } = taskSizes[value];
        setTaskValue(label);
        setTaskDescription(description);
        setImageSize(size);
    };

    const handleSliderChange = (event) => {
        const value = event.target.value;
        changeSize(value);
        setTaskLabels(value);
        setEffortLevel(value)
    }

    const handleBlur = (selectedTask) => {
        const sliderValue = selectedTask.target.value;
        changeSize(sliderValue);
        setTaskLabels(sliderValue);
        setShowInput(false);
        setEffortLevel(sliderValue);
    };

    const handleIconClick = (value) => {
        changeSize(value);
        setTaskLabels(value.toString());
        setEffortLevel(value);
    };

    return (
        <>
            <button className="gt-button-field" onClick={handleClick} ref={buttonRef}>
                <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={imageSize === 'small' ? `#globaltasks-svg-effort-empty` : `#globaltasks-svg-effort-${imageSize}`}></use>
                </svg>
                {taskValue ? taskValue : "Task Size"}
            </button>
            {showInput && (
                <>
                    <div className="gt-effort__backdrop gt-mobile-only"></div>
                    <div className="gt-effort__dropdown" ref={ ref}>
                        <button
                            className="gw-icon-button gw-icon-button--icon gt-mobile-only"
                            aria-label="close dialog"
                            onClick={handleClick}
                        >
                            <i className="gw-icon-button__icon gw-button__icon--close"></i>
                        </button>
                        <input
                            className="gt-effort__slider"
                            value={effortLevel} 
                            type="range"
                            min="0"
                            max="2"
                            step="1"
                            onBlur={handleBlur}
                            onChange={handleSliderChange}
                        />

                        <div className="gt-effort__icons">
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleIconClick(0)}
                                className="effortStyle">
                                <use xlinkHref="#globaltasks-svg-effort-empty"></use>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleIconClick(1)}
                                className="effortStyle">
                                <use xlinkHref="#globaltasks-svg-effort-medium"></use>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleIconClick(2)}
                                className="effortStyle">
                                <use xlinkHref="#globaltasks-svg-effort-large"></use>
                            </svg>
                        </div>
                        <p className="gt-effort__content">{taskDescription}</p>
                    </div>
                </>
            )}
        </>
    );
};

export default TaskSizeButton;
